import React, { FC } from "react"

import { GroupDocument } from "../../../../contexts/devices-context"
import UploadModuleSettings from "./UploadModuleSettings"
import useModuleAttributes from "../../hooks/useModuleAttributes"

type GroupUploadModuleSettingsProps = {
    group: GroupDocument
}

const _GroupUploadModuleSettings: FC<GroupUploadModuleSettingsProps> = ({ group }) => {
    const attrs = useModuleAttributes<"limit_to_days_ago" | "upload_minimum_interval">(group, "upload_client")

    return <UploadModuleSettings attrs={attrs} organisation={group.organisation} group={group.id} />
}

export default _GroupUploadModuleSettings
